/**
 * Upgrade Twitter profile image URL to a higher resolution variant.
 * Twitter serves _normal (48×48) by default; _bigger gives 73×73,
 * which satisfies Lighthouse's responsive-image check for retina displays.
 */
export function upgradeTwitterAvatar(url: string): string {
  return url.replace(/_normal\.(jpe?g|png|gif|webp)/i, '_bigger.$1');
}
